import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import './block-graph.scss';

class BlockGraph extends PureComponent {
  render() {
    return (
      <div className="block-graph">
        <div className="block-graph-image">
          <img
            src={this.props.content.src}
            alt={this.props.content.title}
          />
        </div>
      </div>
    );
  }
}

BlockGraph.propTypes = {
  content: PropTypes.shape({
    src: PropTypes.string
  })
};

export default BlockGraph;



// WEBPACK FOOTER //
// ./src/components/widgets/StaticRenderer/BlockGraph.js